const countryCurrency = {
    FR: '€',
    ES: '€',
    IT: '€',
    DE: '€',
    GB: '£',
};

export const getCurrency = platform =>
    countryCurrency[platform.toUpperCase?.()];

export default {
    getCurrency,
};
